import {
  pageTranslation as enPage,
  generalTranslation as enGeneral,
} from "./en";
import {
  Lang,
  Page,
  Operation,
  IPageTranslation,
  GeneralTranslationCategory,
  IGeneralTranslation,
} from "./types";

export const getPageTranslationText = <T extends Page, K extends Operation>({
  lang = Lang.EN,
  page,
  op,
}: {
  lang?: Lang;
  page: T;
  op: K;
}): IPageTranslation[T][K] => {
  if (lang === Lang.JP) {
    throw new Error("No translations found");
  }

  return enPage[page][op];
};

const getGeneralTranslationText = <K extends GeneralTranslationCategory>({
  lang = Lang.EN,
  key,
}: {
  lang?: Lang;
  key: K;
}): IGeneralTranslation[K] => {
  if (lang === Lang.JP) {
    throw new Error("No translations found");
  }
  const generalData = enGeneral[key];
  return generalData;
};

// Page Specific translations

// P25 UNIT
export const READ_P25_UNIT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_UNIT,
  op: Operation.READ,
});

export const DELETE_P25_UNIT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_UNIT,
  op: Operation.DELETE,
});

export const EDIT_P25_UNIT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_UNIT,
  op: Operation.EDIT,
});

export const CREATE_P25_UNIT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_UNIT,
  op: Operation.CREATE,
});

// DFSI GROUP
export const READ_DFSI_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_GROUP,
  op: Operation.READ,
});

export const DELETE_DFSI_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_GROUP,
  op: Operation.DELETE,
});

export const EDIT_DFSI_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_GROUP,
  op: Operation.EDIT,
});

export const CREATE_DFSI_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_GROUP,
  op: Operation.CREATE,
});

// DFSI Channel
export const READ_DFSI_CHANNEL_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CHANNEL,
  op: Operation.READ,
});

export const DELETE_DFSI_CHANNEL_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CHANNEL,
  op: Operation.DELETE,
});

export const EDIT_DFSI_CHANNEL_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CHANNEL,
  op: Operation.EDIT,
});

export const CREATE_DFSI_CHANNEL_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CHANNEL,
  op: Operation.CREATE,
});

// FIXED NETWORK ELEMENT
export const READ_FIXED_NETWORK_ELEMENT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.FIXED_NETWORK_ELEMENT,
  op: Operation.READ,
});

export const DELETE_FIXED_NETWORK_ELEMENT_TRANSLATIONS = getPageTranslationText(
  {
    lang: Lang.EN,
    page: Page.FIXED_NETWORK_ELEMENT,
    op: Operation.DELETE,
  }
);

export const EDIT_FIXED_NETWORK_ELEMENT_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.FIXED_NETWORK_ELEMENT,
  op: Operation.EDIT,
});

export const CREATE_FIXED_NETWORK_ELEMENT_TRANSLATIONS = getPageTranslationText(
  {
    lang: Lang.EN,
    page: Page.FIXED_NETWORK_ELEMENT,
    op: Operation.CREATE,
  }
);

// DFSI Connection
export const READ_DFSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CONNECTION,
  op: Operation.READ,
});

export const DELETE_DFSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CONNECTION,
  op: Operation.DELETE,
});

export const EDIT_DFSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CONNECTION,
  op: Operation.EDIT,
});

export const CREATE_DFSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.DFSI_CONNECTION,
  op: Operation.CREATE,
});

// MCPTT Group
export const READ_MCPTT_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_GROUP,
  op: Operation.READ,
});

export const DELETE_MCPTT_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_GROUP,
  op: Operation.DELETE,
});

export const EDIT_MCPTT_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_GROUP,
  op: Operation.EDIT,
});

export const CREATE_MCPTT_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_GROUP,
  op: Operation.CREATE,
});

// MCPTT User
export const READ_MCPTT_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_USER,
  op: Operation.READ,
});

export const DELETE_MCPTT_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_USER,
  op: Operation.DELETE,
});

export const EDIT_MCPTT_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_USER,
  op: Operation.EDIT,
});

export const CREATE_MCPTT_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.MCPTT_USER,
  op: Operation.CREATE,
});

// LMR Group
export const READ_LMR_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_GROUP,
  op: Operation.READ,
});

export const DELETE_LMR_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_GROUP,
  op: Operation.DELETE,
});

export const EDIT_LMR_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_GROUP,
  op: Operation.EDIT,
});

export const CREATE_LMR_GROUP_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_GROUP,
  op: Operation.CREATE,
});

// LMR User
export const READ_LMR_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_USER,
  op: Operation.READ,
});

export const DELETE_LMR_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_USER,
  op: Operation.DELETE,
});

export const EDIT_LMR_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_USER,
  op: Operation.EDIT,
});

export const CREATE_LMR_USER_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LMR_USER,
  op: Operation.CREATE,
});

// CANNED MESSAGES
export const READ_CANNED_MESSAGE_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.CANNED_MESSAGE,
  op: Operation.READ,
});

export const DELETE_CANNED_MESSAGE_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.CANNED_MESSAGE,
  op: Operation.DELETE,
});

export const EDIT_CANNED_MESSAGE_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.CANNED_MESSAGE,
  op: Operation.EDIT,
});

export const CREATE_CANNED_MESSAGE_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.CANNED_MESSAGE,
  op: Operation.CREATE,
});

// OTAR_CONNECTION
export const READ_OTAR_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OTAR_CONNECTION,
  op: Operation.READ,
});

export const DELETE_OTAR_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OTAR_CONNECTION,
  op: Operation.DELETE,
});

export const EDIT_OTAR_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OTAR_CONNECTION,
  op: Operation.EDIT,
});

export const CREATE_OTAR_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OTAR_CONNECTION,
  op: Operation.CREATE,
});

// ORG_TRANSLATION
export const READ_ORG_TRANSLATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_TRANSLATION,
  op: Operation.READ,
});

export const DELETE_ORG_TRANSLATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_TRANSLATION,
  op: Operation.DELETE,
});

export const EDIT_ORG_TRANSLATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_TRANSLATION,
  op: Operation.EDIT,
});

export const CREATE_ORG_TRANSLATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_TRANSLATION,
  op: Operation.CREATE,
});

// ORG_MAPPING
export const READ_ORG_MAPPING_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_MAPPING,
  op: Operation.READ,
});

export const DELETE_ORG_MAPPING_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_MAPPING,
  op: Operation.DELETE,
});

export const EDIT_ORG_MAPPING_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_MAPPING,
  op: Operation.EDIT,
});

export const CREATE_ORG_MAPPING_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG_MAPPING,
  op: Operation.CREATE,
});

// ORG
export const READ_ORG_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG,
  op: Operation.READ,
});

export const DELETE_ORG_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG,
  op: Operation.DELETE,
});

export const EDIT_ORG_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG,
  op: Operation.EDIT,
});

export const CREATE_ORG_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG,
  op: Operation.CREATE,
});

// LOCATION
export const READ_LOCATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.READ,
});

export const DELETE_LOCATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.DELETE,
});

export const EDIT_LOCATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.EDIT,
});

export const CREATE_LOCATION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.CREATE,
});

// XSSI_CONNECTION
export const READ_XSSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.XSSI_CONNECTION,
  op: Operation.READ,
});

export const DELETE_XSSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.XSSI_CONNECTION,
  op: Operation.DELETE,
});

export const EDIT_XSSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.XSSI_CONNECTION,
  op: Operation.EDIT,
});

export const CREATE_XSSI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.XSSI_CONNECTION,
  op: Operation.CREATE,
});

// IKI_CONNECTION
export const READ_IKI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.IKI_CONNECTION,
  op: Operation.READ,
});

export const DELETE_IKI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.IKI_CONNECTION,
  op: Operation.DELETE,
});

export const EDIT_IKI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.IKI_CONNECTION,
  op: Operation.EDIT,
});

export const CREATE_IKI_CONNECTION_TRANSLATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.IKI_CONNECTION,
  op: Operation.CREATE,
});

// P25_GROUP
export const READ_P25_GROUP = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_GROUP,
  op: Operation.READ,
});

export const CREATE_P25_GROUP = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_GROUP,
  op: Operation.CREATE,
});

export const EDIT_P25_GROUP = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_GROUP,
  op: Operation.EDIT,
});

export const DELETE_P25_GROUP = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_GROUP,
  op: Operation.DELETE,
});

// P25_AFFILIATIONS
export const READ_P25_AFFILIATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_AFFILIATIONS,
  op: Operation.READ,
});

export const CREATE_P25_AFFILIATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_AFFILIATIONS,
  op: Operation.CREATE,
});

export const EDIT_P25_AFFILIATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_AFFILIATIONS,
  op: Operation.EDIT,
});

export const DELETE_P25_AFFILIATIONS = getPageTranslationText({
  lang: Lang.EN,
  page: Page.P25_AFFILIATIONS,
  op: Operation.DELETE,
});

// Overview
export const READ_OVERVIEW_TRANSLATION = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OVERVIEW,
  op: Operation.READ,
});

export const CREATE_OVERVIEW_TRANSLATION = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OVERVIEW,
  op: Operation.CREATE,
});

export const EDIT_OVERVIEW_TRANSLATION = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OVERVIEW,
  op: Operation.EDIT,
});

export const DELETE_OVERVIEW_TRANSLATION = getPageTranslationText({
  lang: Lang.EN,
  page: Page.OVERVIEW,
  op: Operation.DELETE,
});

// ACTIVE_ALARMS
export const READ_ACTIVE_ALARM = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ACTIVE_ALARM,
  op: Operation.READ,
});

// General Translations
export const TABLE_HEADERS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.TABLE_HEADERS,
});
export const PERMISSIONS_TRANSLATIONS = {
  header: getGeneralTranslationText({
    lang: Lang.EN,
    key: GeneralTranslationCategory.PERMISSION_DENIED_HEADER,
  }),
  subtext: getGeneralTranslationText({
    lang: Lang.EN,
    key: GeneralTranslationCategory.PERMISSION_DENIED_SUBTEXT,
  }),
};
export const ADVANCED_SEARCH_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.ADVANCED_SEARCH,
});
export const EDIT_FORM_FIELDS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.EDIT_FORM_FIELDS,
});
export const ADD_FORM_FIELDS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.ADD_FORM_FIELDS,
});
export const EDIT_ROW_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.EDIT_ROW,
});
export const EDIT_GROUP_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.EDIT_GROUP,
});
export const EDIT_ORG_PROFILE_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.EDIT_ORG_PROFILE,
});
export const VIEW_FORM_FIELDS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.VIEW_FORM_FIELDS,
});
export const LOADING_TEXT_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.LOADING_TEXT,
});
export const SIDEPANEL_GENERAL_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.SIDEPANEL_GENERAL,
});

export const CREATE_NEW_BTN_LABEL_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.CREATE_NEW_BTN_LABEL,
});

export const FORM_VALIDATION_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.FORM_VALIDATION,
});
export const TABLE_SEARCH_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.TABLE_SEARCH,
});
export const BREADCRUMBS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.BREADCRUMBS,
});
export const TOGGLE_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.TOGGLE,
});
export const HEX_INPUT_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.HEX_INPUT,
});
export const MISC_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.MISC,
});

export const FILTER_COLUMNS_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.FILTER_COLUMNS,
});

export const TAB_LIST_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.TAB_LIST,
});

export const TILE_LIST_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.TILE_LIST,
});

export const OVERVIEW_TILE_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.OVERVIEW_TILE,
});

export const AUTH_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.AUTH,
});

export const DATA_TABLE_GENERAL_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.DATA_TABLE_GENERAL,
});

export const MENU_TEXT_GENERAL_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.MENU_TEXT,
});
export const BULK_UPLOAD_GENERAL_TRANSLATIONS = getGeneralTranslationText({
  lang: Lang.EN,
  key: GeneralTranslationCategory.BULK_UPLOAD,
});
